import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import withWidth from 'material-ui/utils/withWidth'
import compose from 'recompose/compose'
import {connect} from 'react-redux'

import styles from '../styles'
import Addresses from '../components/Addresses'
import actions from '../actions/addresses'

class AddressesContainer extends React.Component {

  render() {
    return <Addresses {...this.props}/>
  }
}

AddressesContainer.propTypes = {
  addresses: PropTypes.array,
  editDialog: PropTypes.bool,
  addDialog: PropTypes.bool,
  removeDialog: PropTypes.bool,
  selected: PropTypes.shape({
    id: PropTypes.number,
    address: PropTypes.string,
    number: PropTypes.string,
    floor: PropTypes.string,
    apartment: PropTypes.string,
    postalCode: PropTypes.string,
    emptyFieldErrors: PropTypes.shape({
      address: PropTypes.string,
      number: PropTypes.string,
      postalCode: PropTypes.string,
    })
  }),
  isLoading: PropTypes.bool,
  error: PropTypes.string,
}

const mapStateToProps = state => {
  const data = state.ui.profile.addresses
  return {
    addresses: data.get('addresses').toArray(),
    editDialog: data.get('editDialogShow'),
    addDialog: data.get('addDialogShow'),
    removeDialog: data.get('removeDialogShow'),
    selected: {
      id: data.getIn(['selected', 'id']),
      original: data.getIn(['selected', 'original']),
      address: data.getIn(['selected', 'address']),
      number: data.getIn(['selected', 'number']),
      floor: data.getIn(['selected', 'floor']),
      apartment: data.getIn(['selected', 'apartment']),
      postalCode: data.getIn(['selected', 'postalCode']),
      emptyFieldErrors: data.getIn(['selected', 'emptyFieldErrors']).toObject(),
    },
    isLoading: data.get('isLoading'),
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    edit: (key, id, original, address, number, floor, apartment, postalCode) => dispatch(actions.edit(key, id, original, address, number, floor, apartment, postalCode)),
    setEditDialogOpen: show => dispatch(actions.setEditDialogOpen(show)),
    saveEdit: key => dispatch(actions.saveEdit(key)),
    add: () => dispatch(actions.add()),
    setAddDialogOpen: show => dispatch(actions.setAddDialogOpen(show)),
    saveAdd: () => dispatch(actions.saveAdd()),
    setOriginal: original => dispatch(actions.setOriginal(original)),
    setAddress: address => dispatch(actions.setAddress(address)),
    setFloor: floor => dispatch(actions.setFloor(floor)),
    setApartment: apartment => dispatch(actions.setApartment(apartment)),
    setPostalCode: postalCode => dispatch(actions.setPostalCode(postalCode)),
    setStreetNumber: number => dispatch(actions.setStreetNumber(number)),
    remove: (key, id, address) => dispatch(actions.remove(key, id, address)),
    setRemoveDialogOpen: show => dispatch(actions.setRemoveDialogOpen(show)),
    saveRemove: key => dispatch(actions.saveRemove(key)),
  }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(AddressesContainer)
const Styled = compose(withStyles(styles, {withTheme: true}), withWidth())(Container)

export default Styled



// WEBPACK FOOTER //
// ./src/sections/profile/containers/addresses.js